export interface ClosePromptModel {
  /** the text that will appear on the close prompt dialog. Should be localized. */
  message: string;
  /** this decides whether the prompt should be shown or not */
  shouldDisplayClosePrompt: boolean;
}

export interface ClosePromptService {
  /** registers a close prompt message on the provided state
   * @param stateName name of the state against which callback will be registered
   * @param closePromptCallback should return ClosePromptModel
   */
  register(stateName: string, closePromptCallback: () => ClosePromptModel): void;
  /** method to unregister a close prompt service
   * @param stateName name of the state against which callback will be registered
   */
  unregister(stateName: string): void;
}

export class ClosePromptServiceImplementation {
  // maintains a map of state to close prompt callbacks
  public static closePromptStateMap = new Map<string, any>();

  constructor() {}

  public register(stateName: string, closePromptCallback: any) {
    if (ClosePromptServiceImplementation.closePromptStateMap.has(stateName)) {
      throw new Error("Callback for this state is already registered.");
    }

    ClosePromptServiceImplementation.closePromptStateMap.set(stateName, closePromptCallback);
  }

  public unregister(stateName: string) {
    if (ClosePromptServiceImplementation.closePromptStateMap.has(stateName)) {
      ClosePromptServiceImplementation.closePromptStateMap.delete(stateName);
    }
  }
}
